import { render } from "./UpdatePrompt.vue?vue&type=template&id=c951670a&scoped=true"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js"

import "./UpdatePrompt.vue?vue&type=style&index=0&id=c951670a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c951670a"]])

export default __exports__